// extracted by mini-css-extract-plugin
export var closeBtn = "ChooseRegionModal-module--closeBtn--5f589";
export var contentWrapp = "ChooseRegionModal-module--contentWrapp--3fb0d";
export var flagsList = "ChooseRegionModal-module--flagsList--e4ae7";
export var modal = "ChooseRegionModal-module--modal--156f9";
export var overlay = "ChooseRegionModal-module--overlay--358ec";
export var text = "ChooseRegionModal-module--text--64372";
export var title = "ChooseRegionModal-module--title--1e0a7";